export interface LoadCompanyOutputApiModel {
    company_email: string;
    company_id: number;
    company_name: string;
    time_created: Date;
    avatar: string;
    slug: string;
    is_public: boolean;
    avg_points: number;
}

export interface LoadUserBadgeApiModel {
    id: number;
    image: string;
    name: string;
    text: string;
    color: string;
    given_case: string;
}

export interface LoadUserStoryStatisticsOutputApiModel {
    total: number;
    given: number;
    received: number;
    people_named: number;
    people_added: number;
}

export interface LoadUserStoryFrequentTagsOutputApiModel {
    title: string;
    color: string;
    data: Array<string>;
    sort: number;
}

export interface LoadUserProfileOutputApiModel {
    id: number;
    is_approved_outsider: number;
    admin_role?:number
    display_name: string;
    first_name: string;
    last_name: string;
    avatar: string;
    bg_header: string;
    slug: string;
    email: string;
    profile_twitter: string;
    profile_linkedin: string;
    profile_facebook: string;
    work_purpose: string;
    work_location: string;
    follow_id: number;
    title: string;
    company: LoadCompanyOutputApiModel;
    badge?: LoadUserBadgeApiModel;
    story_statistics?: LoadUserStoryStatisticsOutputApiModel;
    frequent_tags?: LoadUserStoryFrequentTagsOutputApiModel[];
    admin_companies: number[];
    work_attributes: any;
    follow_enable: boolean;
    public: boolean;
    story_invite_enable: boolean;
    name_public: boolean;
    user_points: number;
    status: number;
    signed_up_at: Date;
}
